var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useAuth } from '../../context/AuthContext';
import keycloakConfig from '../../../public/keycloak.json';
export const LoginPage = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const { finishAmeiLogin } = useAuth();
    const setCookie = (cname, cvalue) => {
        const d = new Date();
        d.setTime(d.getTime() + (5 * 60 * 1000)); // 5 minutos
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };
    useEffect(() => {
        var _a, _b;
        // Persist redirect path if present in location state (before potential Keycloak redirect)
        if ((_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.from) === null || _b === void 0 ? void 0 : _b.pathname) {
            sessionStorage.setItem('auth_redirect_path', location.state.from.pathname);
        }
        const initKeycloak = () => __awaiter(void 0, void 0, void 0, function* () {
            if (document.getElementById('keycloak-script')) {
                if (window.Keycloak) {
                    // Lógica de reinicialização se necessário
                }
                return;
            }
            const script = document.createElement('script');
            script.id = 'keycloak-script';
            script.src = "https://amei.homolog.kubernetes.sebrae.com.br/auth/js/keycloak.js";
            script.async = true;
            script.onload = () => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b;
                try {
                    const Keycloak = window.Keycloak;
                    if (!Keycloak) {
                        throw new Error("Keycloak SDK not loaded");
                    }
                    const keycloak = new Keycloak(keycloakConfig);
                    const authenticated = yield keycloak.init({
                        onLoad: 'login-required'
                    });
                    if (authenticated) {
                        console.log("Authenticated! Token:", keycloak.token);
                        const dataExp = new Date();
                        dataExp.setDate(dataExp.getDate() + 1);
                        setCookie("amei_token", keycloak.token);
                        document.cookie = `amei_idtoken=${keycloak.idToken}; expires=${dataExp.toUTCString()}; path=/`;
                        // Chama o método do contexto para finalizar o login e recuperar dados do usuário
                        yield finishAmeiLogin(keycloak.token);
                        // Redireciona para a rota original ou home (recuperando de state ou sessionStorage)
                        const storedPath = sessionStorage.getItem('auth_redirect_path');
                        const from = ((_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.from) === null || _b === void 0 ? void 0 : _b.pathname) || storedPath || '/';
                        // Limpa o path salvo para não interferir em navegações futuras
                        if (storedPath)
                            sessionStorage.removeItem('auth_redirect_path');
                        navigate(from, { replace: true });
                    }
                    else {
                        setError("Acesso impossibilitado no momento - Erro 2002");
                        setLoading(false);
                    }
                }
                catch (error) {
                    console.error("Keycloak init error:", error);
                    setError("Acesso impossibilitado no momento - Erro 2003");
                    setLoading(false);
                }
            });
            script.onerror = () => {
                setError("Erro ao carregar biblioteca de autenticação.");
                setLoading(false);
            };
            document.body.appendChild(script);
        });
        const timer = setTimeout(() => {
            initKeycloak();
        }, 100);
        return () => clearTimeout(timer);
    }, [navigate, finishAmeiLogin, location]);
    if (loading) {
        return (_jsx("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }, children: _jsx("p", { children: "Aguarde, redirecionando para login..." }) }));
    }
    if (error) {
        return (_jsxs("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }, children: [_jsx("p", { style: { color: 'red' }, children: error }), _jsx("button", { onClick: () => window.location.reload(), children: "Tentar novamente" })] }));
    }
    return null;
};
//# sourceMappingURL=Login.js.map